import axios from "axios";
import { setInBothStorages } from "./logics";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

export const googleLogin = async (code, hostname) => {
  let res = await axios.get(`${API_URL}/v1/auth/google/callback?code=${code}`, {
    withCredentials: true,
  });

  setInBothStorages("email", res.data.email);
  setInBothStorages("token", res.data.token);
  setInBothStorages("expiry_in", res.data.expires_in);
  setInBothStorages("is_super_admin", res.data.is_super_admin);
};

export const spLogin = async token => {
  let res = await axios.get(`${API_URL}/v1/auth/sp/callback?token=${token}`, {
    withCredentials: true,
  });

  setInBothStorages("email", res.data.email);
  setInBothStorages("token", res.data.token);
  setInBothStorages("expiry_in", res.data.expires_in);
  setInBothStorages("is_super_admin", res.data.is_super_admin);
};

export const isAuthenticated = async () => {
  // Check if the token is expired before making the request
  if (isTokenExpired()) {
    const refreshSuccess = await getRefreshToken();
    if (!refreshSuccess) {
      // If the refresh failed, return false to indicate the user is not authenticated
      return false;
    }
  }

  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  try {
    const res = await axios.get(`${API_URL}/v1/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    const data = res.data;
    setInBothStorages("profile", data.user.profile_image);
    setInBothStorages("firstname", data.user.first_name);
    setInBothStorages("lastname", data.user.last_name);
    setInBothStorages("role", data.role);
    setInBothStorages("storeid", data?.store?.id);
    setInBothStorages("documentUploaded", data.store?.is_document_uploaded);
    setInBothStorages("emailaccount", data.store?.is_email_account_added);
    setInBothStorages("shopifyaccount", data.store?.is_shopify_account_added);
    setInBothStorages("isonboarded", data.store?.is_onboarded);
    setInBothStorages("preferedlanguage", data.user?.prefered_language);
    setInBothStorages("storename", data?.store?.name);
    setInBothStorages("storedata", data?.store?.store_id);
    setInBothStorages("signed-on", data?.user?.created_at);
    setInBothStorages("id", data.user.id);
    setInBothStorages("isLoggedIn", "true");

    return true;
  } catch (error) {
    getRefreshToken();
    return false;
  }
};

export const getRefreshToken = async () => {
  const isLoggedIn = sessionStorage.getItem("isLoggedIn") || localStorage.getItem("isLoggedIn");
  const isSuperAdmin = sessionStorage.getItem("is_super_admin") || localStorage.getItem("is_super_admin");
  const sessionStoreid = sessionStorage.getItem("storeid");
  const localStoreid = localStorage.getItem("storeid");
  if (isLoggedIn === "false") {
    window.location.href = "/signin";
    return;
  }

  let storeid = null;
  if (isSuperAdmin?.toLowerCase() === "true" && sessionStoreid === "undefined") {
    storeid = null;
  } else if (sessionStoreid && sessionStoreid !== "null" && sessionStoreid !== "undefined") {
    storeid = sessionStoreid;
  } else {
    storeid = localStoreid;
  }

  try {
    const res = await axios.post(
      `${API_URL}/v1/auth/token/refresh`,
      {},
      {
        withCredentials: true,
        params: {
          store_id: storeid,
        },
      }
    );
    // Assuming the response contains the new token and its expiration time
    if (isSuperAdmin === "False" || (isSuperAdmin === "True" && sessionStoreid === "undefined")) {
      localStorage.setItem("email", res.data.email);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("expiry_in", res.data.expires_in);
      localStorage.setItem("is_super_admin", res.data.is_super_admin);
    }

    /*sessionstorage*/
    sessionStorage.setItem("email", res.data.email);
    sessionStorage.setItem("token", res.data.token);
    sessionStorage.setItem("expiry_in", res.data.expires_in);
    sessionStorage.setItem("is_super_admin", res.data.is_super_admin);
    return true;
  } catch (err) {
    toast.error(err.response?.data?.detail || "Token has expired", {
      toastId: "token-expired", // Prevents duplicate toasts
    });
    localStorage.clear();
    sessionStorage.clear();
    setInBothStorages("isLoggedIn", "false");
    setTimeout(() => {
      window.location.href = "/signin";
    }, 100); // Give the browser time to flush logs
    return false;
  }
};

export const isTokenExpired = () => {
  const tokenExpiryTime = sessionStorage.getItem("expiry_in") || localStorage.getItem("expiry_in");

  if (!tokenExpiryTime) {
    return true;
  }

  const currentTime = new Date();
  const expiryTime = new Date(tokenExpiryTime);
  return currentTime > expiryTime;
};

export const EmailSignup = async (email, password, confirm_password, first_name, last_name) => {
  // Create FormData instance
  const formData = new FormData();
  formData.append("first_name", first_name);
  formData.append("last_name", last_name);
  formData.append("email", email);
  formData.append("password", password);
  formData.append("confirm_password", confirm_password);

  // Send POST request with form-data
  const response = await axios.post(`${API_URL}/v1/auth/signup`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Important for form-data
    },
  });

  return response.data; // Return the server response
};

export const EmailSignin = async (email, password) => {
  // Create a FormData object
  const formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);

  // Make the API request
  const res = await axios.post(`${API_URL}/v1/auth/login`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures the request is sent as form-data
    },
  });

  // // Save data in both storages
  if (res?.data?.is_verified !== "False") {
    setInBothStorages("email", res?.data?.email);
    setInBothStorages("token", res?.data?.token);
    setInBothStorages("expiry_in", res?.data?.expires_in);
    setInBothStorages("is_super_admin", res?.data?.is_super_admin);
  }
  return res.data; // Return the response data for further processing
};

export const verifyEmailAPI = async (email, verification_code) => {
  // Create a FormData object
  const formData = new FormData();
  formData.append("email", email);
  formData.append("verification_code", verification_code);

  // Make the API request
  const response = await axios.post(`${API_URL}/v1/auth/verify-email`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures form-data is sent correctly
    },
  });

  return response.data;
};
